





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Title extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/title/Title.vue